export default "__VITE_ASSET__0ee5b89f__"